import { createMedia, createSpacing } from './mixins';

import type { RecursivePartial, RequiredBy } from '@toolbox/utils';
import type { BaseTheme, ExtendTheme } from './typings';

export const createTheme = <
  T extends RequiredBy<RecursivePartial<BaseTheme>, 'spacings' | 'breakpoints'>,
>(
  theme: T,
): ExtendTheme<T> => ({
  ...theme,
  spacing: createSpacing(theme),
  media: createMedia(theme),
});
